import { render, staticRenderFns } from "./TermsAndConditionsWikihow.vue?vue&type=template&id=0fd933ba&"
import script from "./TermsAndConditionsWikihow.vue?vue&type=script&lang=ts&"
export * from "./TermsAndConditionsWikihow.vue?vue&type=script&lang=ts&"
import style0 from "./TermsAndConditionsWikihow.vue?vue&type=style&index=0&id=0fd933ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports